// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist2-schedule-edit-schedule-time .checklist-schedule-time-interval-badge {
  padding: 10px 24px;
  font-size: 16px;
  border-radius: 100px;
  width: fit-content;
  margin-bottom: 24px;
  background-color: var(--fi-color-red-darkened);
  color: var(--fi-color-white);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/schedule/schedule-edit/schedule-time/schedule-time.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,4BAAA;AAAR","sourcesContent":[".fi-checklist2-schedule-edit-schedule-time {\r\n    .checklist-schedule-time-interval-badge {\r\n        padding: 10px 24px;\r\n        font-size: 16px;\r\n        border-radius: 100px;\r\n        width: fit-content;\r\n        margin-bottom: 24px;\r\n        background-color: var(--fi-color-red-darkened);\r\n        color: var(--fi-color-white);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
